export default "__VITE_ASSET__Bir5DDa4__"